<template>
  <div>
    <div class="row my-1">
      <div class="offset-4 col-8 d-flex">
        <input v-model="startDate" class="form-control form-control-sm mx-2" type="month" />
        <input v-model="endDate" class="form-control form-control-sm mx-2" type="month" />
        <button
          @click="$parent.getMonthlyStats(startDate, endDate)"
          class="btn btn-sm btn-outline-info float-right mr-2"
        >Харах</button>
        <button
          @click="$parent.onDownloadExcel('banner_stat_monthly_excel/' + bannerId, startDate, endDate)"
          class="btn btn-sm btn-outline-success"
        >Excel татах</button>
      </div>
    </div>
    <h1 class="stat__title">Үзэлтийн статистик</h1>
    <bar-chart v-if="hasViewStat" :data="viewStats" :stacked="false" class="stat-box" />
    <div v-else class="text-secondary text-center">
      <i class="fas fa-exclamation-circle"></i>
      Өгөгдөл олдсонгүй
    </div>
    <br />
    <h1 class="stat__title">Даралтын статистик</h1>
    <bar-chart v-if="hasClickStat" :data="clickStats" :stacked="false" class="stat-box" />
    <div v-else class="text-secondary text-center">
      <i class="fas fa-exclamation-circle"></i>
      Өгөгдөл олдсонгүй
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/chart/BarChart";

export default {
  name: "BannerStatisticMonthly",

  components: { BarChart },

  props: ["monthlyStat", "start", "end"],

  watch: {
    monthlyStat: function() {
      this.makeData();
    }
  },

  created() {
    this.makeData();
  },

  computed: {
    bannerId: function() {
      return this.$route.params.id;
    },

    hasViewStat: function() {
      return (
        this.monthlyStat.stat.banner_view_pc != null &&
        this.monthlyStat.stat.banner_view_android != null &&
        this.monthlyStat.stat.banner_view_ios != null
      );
    },

    hasClickStat: function() {
      return (
        this.monthlyStat.stat.banner_click_pc != null &&
        this.monthlyStat.stat.banner_click_android != null &&
        this.monthlyStat.stat.banner_click_ios != null
      );
    }
  },

  data() {
    return {
      viewStats: null,
      clickStats: null,

      startDate: this.start,
      endDate: this.end
    };
  },

  methods: {
    makeData() {
      this.viewStats = this.hasViewStat
        ? this.makeStatsData(this.monthlyStat, [
            {
              name: "banner_view_pc",
              displayName: "Компьютер үзэлт",
              color: "#f87979"
            },
            {
              name: "banner_view_android",
              displayName: "Андройд үзэлт",
              color: "#a87979"
            },
            {
              name: "banner_view_ios",
              displayName: "IOS үзэлт",
              color: "#4682B4"
            }
          ])
        : null;

      this.clickStats = this.hasClickStat
        ? this.makeStatsData(this.monthlyStat, [
            {
              name: "banner_click_pc",
              displayName: "Компьютер даралт",
              color: "#f87979"
            },
            {
              name: "banner_click_android",
              displayName: "Андройд даралт",
              color: "#a87979"
            },
            {
              name: "banner_click_ios",
              displayName: "IOS даралт",
              color: "#4682B4"
            }
          ])
        : null;
    },

    makeStatsData(response, charts) {
      let stats = {};
      let dates = this.dateRange(response.startDate, response.endDate);

      stats.labels = dates; //labels set

      let stat = response.stat;

      let datasets = [];

      charts.forEach(chart => {
        let dataset = {};
        dataset.label = chart.displayName;
        dataset.backgroundColor = chart.color;
        dataset.data = [];
        dates.forEach(date => {
          let index = this.searchByDate(stat[chart.name], date);
          dataset.data.push(index > -1 ? stat[chart.name][index].count : null);
        });
        datasets.push(dataset);
      });

      stats.datasets = datasets; //datasets set

      return stats;
    },

    dateRange(startDate, endDate) {
      var start = startDate.split("-");
      var end = endDate.split("-");
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          var j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          var month = j + 1;
          var displayMonth = month < 10 ? "0" + month : month;
          dates.push([i, displayMonth].join("-"));
        }
      }
      return dates;
    },

    searchByDate(objArr, date) {
      return objArr.map(x => x.accessDate).indexOf(date);
    }
  }
};
</script>